<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="settlement_id">
                                            {{ $t('label.settlement_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="settlement_id"
                                                dir="ltr"
                                                name="settlement_id"
                                                id="settlement_id"
                                                v-model="query.settlement_id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="amount">
                                            {{ $t('label.amount') }}
                                        </kt-form-label>
                                        <kt-form-control ref="amount" dir="ltr" name="amount" id="amount" v-model="query.amount" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="filter_status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="4" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4"  lg="4" class="pb-3">
                                <kt-form-label for="filter_gateway">
                                  {{ $t('label.gateway') }}
                                </kt-form-label>
                                <select
                                    class="form-control"
                                    v-model=filter_gateway
                                    name = "filter_gateway"
                                    id="filter_gateway"
                                >
                                  <option
                                      :key="index"
                                      v-for="(data, index) in shop_data_gateway"
                                      :value = data
                                  >
                                    {{ data.title+"  -  "+getShopType(data.shop_type)+"  -  "+data.sequence}}
                                  </option>
                                </select>
                              </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { statusStrForCommonAccess, settlementStatus } from '@/constants/settlementStatus'
import {mapGetters} from "vuex";
import  { AllShopTypes } from "@/constants/AllShopTypes"
import { i18n } from "@/plugins/i18n";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: statusStrForCommonAccess.PENDING,
                    value: settlementStatus.PENDING
                },
                {
                    name: statusStrForCommonAccess.ACCEPTED,
                    value: settlementStatus.ACCEPTED
                },
                {
                    name: statusStrForCommonAccess.REJECTED,
                    value: settlementStatus.REJECTED
                },
            ],
            query: {},
            filter_gateway: null,
        }
    },
    watch: {
      filter_gateway(value) {
        this.query.shop_type   = value.shop_type;
        this.query.shop_id     = value.shop_id;
      }
    },
    computed : {
      ...mapGetters('gateway', [
        'shop_data_gateway',
        'shop_data_gateway_status'
      ]),
    },
    methods: {
      getShopType(shop_type) {
        if (shop_type == AllShopTypes.PAYMENT_HELPER) {
          return  i18n.t('label.payment_helper')
        }
        if (shop_type == AllShopTypes.PAYMAN) {
          return  i18n.t('label.payman')
        }
        if (shop_type == AllShopTypes.IVR) {
          return  i18n.t('label.ivr')
        }
        if (shop_type == AllShopTypes.DEDICATED) {
          return  i18n.t('label.dedicated')
        }
      },
    },
    mounted() {
      this.$store.dispatch('gateway/fetchShopData')
    }
    
}
</script>

<style>

</style>